import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section id="problem" className="py-24 border-b border-stone-300" data-id="element-1134">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1135">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1136">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1137">
            The Problem
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-12 max-w-3xl" data-id="element-1138">
            Group travel still runs on email. That costs you millions.
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1139">
            {/* Left: Problem description */}
            <div className="lg:col-span-5" data-id="element-1140">
              <p className="text-lg text-stone-600 leading-relaxed mb-8" data-id="element-1141">
                The group segment is the last major hospitality vertical still
                relying on manual email-based quoting. Every RFP triggers a
                cascade of delays, errors, and lost revenue.
              </p>
              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-1142">
                Meanwhile, wholesalers capture margin that belongs to you—hidden
                in the P&L, rarely measured, entirely preventable.
              </p>
            </div>

            {/* Right: Data points */}
            <div className="lg:col-span-7" data-id="element-1143">
              <div className="border-t border-stone-300" data-id="element-1144">
                <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-1145">
                  <div className="border-b md:border-b-0 md:border-r border-stone-300 py-8 pr-8" data-id="element-1146">
                    <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1147">
                      Quote Response Time
                    </p>
                    <p className="font-mono text-4xl text-stone-900 mb-2" data-id="element-1148">
                      48–72<span className="text-sm ml-1" data-id="element-1149">hrs</span>
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1150">
                      Groups book elsewhere while you're still pricing
                    </p>
                  </div>

                  <div className="border-b md:border-b-0 md:border-r border-stone-300 py-8 px-8" data-id="element-1151">
                    <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1152">
                      Wholesale Margin Capture
                    </p>
                    <p className="font-mono text-4xl text-stone-900 mb-2" data-id="element-1153">
                      15–25<span className="text-sm ml-1" data-id="element-1154">%</span>
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1155">
                      Revenue you could keep with direct distribution
                    </p>
                  </div>

                  <div className="py-8 pl-8" data-id="element-1156">
                    <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1157">
                      Pricing Visibility
                    </p>
                    <p className="font-mono text-4xl text-stone-900 mb-2" data-id="element-1158">
                      0<span className="text-sm ml-1" data-id="element-1159">%</span>
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1160">
                      No audit trail, no governance, no control
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}